import Events from '@utilities/events';
import { SessionStorage } from '@utilities/storage';
import RafThrottle from '@utilities/raf-throttle';
import ScrollTo from '@utilities/scroll-to';

const ACTIVE_CLASS = 'has--brand-banner';

const CLOSE_BUTTON_HOOK = '[js-hook-brand-banner-close]';
const SCROLL_BUTTON_HOOK = '[js-hook-brand-banner-scroll-button]';
const PAGE_TITLE_HOOK = '[js-hook-page-title]';

class BrandBanner {
    constructor(element) {
        this.element = element;
        this.body = document.querySelector('body');
        this.closeButton = element.querySelector(CLOSE_BUTTON_HOOK);
        this.showBannerStatus = true;

        this.checkBannerVisibility();
        this.scrollToButtonsHandler();

        this.bindEvents();
    }

    /**
     * Bind all events
     */
    bindEvents() {
        Events.$on('brand-banner::toggle', () => this.toggleBrandBanner());

        this.closeButton.addEventListener('click', () => this.hideBrandBanner());

        RafThrottle.set([
            {
                element: window,
                event: 'resize',
                namespace: 'brandBannerResize',
                fn: () => this.scrollToButtonsHandler(),
            },
        ]);
    }

    checkBannerVisibility() {
        const storedBrandBannerObj = SessionStorage.get('BrandBanner');

        if (!storedBrandBannerObj || storedBrandBannerObj.viewed !== true) {
            this.showBrandBanner();
        } else {
            this.showBannerStatus = false;
        }
    }

    toggleBrandBanner() {
        if (this.showBannerStatus) {
            this.body.classList.toggle(ACTIVE_CLASS);
        }
    }

    showBrandBanner() {
        SessionStorage.set('BrandBanner', { viewed: true });

        this.body.classList.add(ACTIVE_CLASS);
    }

    hideBrandBanner() {
        this.body.classList.remove(ACTIVE_CLASS);
        this.showBannerStatus = false;
    }

    scrollToButtonsHandler() {
        this.scrollToButtons = [...this.element.querySelectorAll(SCROLL_BUTTON_HOOK)];

        this.scrollToButtons.forEach(button => {
            button.addEventListener('click', () => {
                ScrollTo.scrollTo(document.querySelector(PAGE_TITLE_HOOK));
            });
        });
    }
}

export default BrandBanner;
